import React from 'react';
import { Category, Task, TaskStatus } from '../types';

interface SidebarProps {
  stageTypes: API.PROJECTHQ.StageType[];
  currentStageType?: API.PROJECTHQ.StageType;
  onStageTypeChange: (v: API.PROJECTHQ.StageType) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ 
  stageTypes,
  currentStageType,
  onStageTypeChange,
}) => {
  
  // Helper to count pending tasks per category in current phase
  // const getPendingCount = (stageTypeId: number) => {
  //   return tasks.filter(t => 
  //     t.stageTypeId === stageTypeId && 
  //     t.status !== TaskStatus.COMPLETED
  //   ).length;
  // };

  return (
    <div className={`w-64 shrink-0 overflow-y-auto border-none py-4 transition-colors duration-200 ${currentStageType ? 'bg-blue-100' : 'bg-gray-100'}`}>
      <div className="space-y-1 pl-4">
        {stageTypes.map((type) => {
          const isActive = type.ID === currentStageType?.ID;
          const totalCount = type.totalCount || 0;
          const completedCount = totalCount - type.uncompletedCount || 0;
          const count = type.uncompletedCount || 0;
          
          return (
              <div
                key={type.ID}
                onClick={() => onStageTypeChange(type)}
                className={`
                w-full cursor-pointer  px-4 py-3 rounded-tl-lg rounded-bl-lg text-sm font-medium transition-all duration-200
                ${isActive
                    ? 'bg-blue-50 text-white'
                    : 'text-gray-600 hover:bg-white hover:text-primary'}
              `}
            >
              <div className={`flex items-center justify-between p-2 ${isActive ? 'text-primary' : ''}`}>
                <div className='flex items-center'>
                  <div className={`shrink-0 w-2 h-2 mr-2 rounded-full ${isActive ? `border-none bg-primary` : 'border border-solid border-primary bg-[#f5f5f5]'}`}></div>
                  <span>{type.name}</span>
                </div>
                
                {count > 0 && (
                  <span className={`
                  flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs rounded-full
                 bg-gray-100 border border-solid border-gray-500 text-gray-500
                `}>
                    {count}
                  </span>
                )}
              </div>
                
            </div>
          );
        })}
        
        {/* Placeholder visualization for list end as per design often seen */}
        <div className="pt-8 px-4 opacity-30 text-xs text-center text-gray-400">
           -- 到底了 --
        </div>
      </div>
    </div>
  );
};